<template>
  <div class="loading" id="loading" v-show="show.value">
    <div class="load_box">
      <img src="@/assets/images/loading.gif" />
      <span>{{ message.value }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Ref } from 'vue'
defineProps<{
  show: Ref<boolean>
  message: Ref<string>
}>()
</script>

<style scoped lang="less">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.6);

  .load_box {
    background-color: #fff;
    width: 140px;
    height: 140px;
    border-radius: 8px;
    color: #3c3c3c;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.8px;
    font-size: 14px;

    img {
      width: 70px;
      height: 70px;
      /* margin-bottom: 14px; */
      /* -webkit-animation: rotate .8s linear infinite; */
    }
  }
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
